module.exports = __webpack_public_path__ + "static/media/CHAP03-TITRE.59623ff8.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Skew/img/CHAP03-TITRE.png
// module id = 272
// module chunks = 0